module.exports = __webpack_public_path__ + "png/hero-confetti-2-1.png";